import { SummaryCardShell } from './summary-card-shell'

interface Props {
  timeInCare: string | null
  careHappened: boolean
  careEnded: boolean
}

export function TimeInCareCard({ timeInCare, careHappened, careEnded }: Props) {
  return (
    <SummaryCardShell className="min-w-[279px] items-start">
      <div className="flex min-h-px min-w-px flex-1 flex-col gap-2">
        <div className="flex w-full items-center justify-between">
          <p className="text-sm font-semibold leading-6 text-charcoal-75">Time in Care</p>

          {careHappened && careEnded && <CareEndedBadge />}
        </div>

        <p className="whitespace-nowrap text-3xl font-bold leading-[1.5] text-charcoal-75">
          {timeInCare || '—'}
        </p>
      </div>
    </SummaryCardShell>
  )
}

function CareEndedBadge() {
  return (
    <div className="flex shrink-0 items-center justify-center gap-2 rounded-2xl border border-forest-light bg-white px-2 py-1">
      <i className="fa-solid fa-check text-[12px] text-forest-light" aria-hidden="true" />
      <p className="text-center text-sm font-medium leading-6 text-forest-light">Care ended</p>
    </div>
  )
}
